import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { isShowSectionForAnnuityPayout } from "js/utilities/isShowSectionForAnnuityPayout";

export default function ServicesQuickLinks() {
  const { t } = useTranslation();

  const { policies } = useSelector((state) => state.data);

  let quickLinkArray = [
    {
      name: t("CustomerServices-quickLinks1-name"),
      route: t("CustomerServices-quickLinks1-route"),
      icon: t("CustomerServices-quickLinks1-icon"),
    },
    {
      name: t("CustomerServices-quickLinks2-name"),
      route: t("CustomerServices-quickLinks2-route"),
      icon: t("CustomerServices-quickLinks2-icon"),
    },
    {
      name: t("CustomerServices-quickLinks3-name"),
      route: t("CustomerServices-quickLinks3-route"),
      icon: t("CustomerServices-quickLinks3-icon"),
    },
    {
      name: t("CustomerServices-quickLinks4-name"),
      route: t("CustomerServices-quickLinks4-route"),
      icon: t("CustomerServices-quickLinks4-icon"),
    },
    {
      name: t("CustomerServices-quickLinks5-name"),
      route: t("CustomerServices-quickLinks5-route"),
      icon: t("CustomerServices-quickLinks5-icon"),
    },
  ];
  const [quickLinks, setQuickLinks] = useState(quickLinkArray);

  useEffect(() => {
    if (!isShowSectionForAnnuityPayout(policies))
      setQuickLinks(quickLinkArray.slice(1));
  }, [policies]);

  return (
    <div className="ui-card pt-4 px-4 ">
      <h2 className="text-center mb-4">
        {t("CustomerServices-quickLinks-title")}
      </h2>
      <div className="grid grid-cols-1">
        {quickLinks.map((link, index) => {
          return (
            <div
              className="mb-4 pb-1 border-b border-theme-rule-light"
              key={`links - ${index}`}
            >
              <Link to={link.route} className="ui-link-icon">
                <svg
                  className="ui-icon w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href={`#${link.icon}`}></use>
                </svg>
                {link.name}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
